<script setup lang="ts">
import 'vue-sonner/style.css';

import { Toaster } from '@/shared/ui/sonner';
import { TooltipProvider } from '@/shared/ui/tooltip';
</script>

<template>
  <div v-cloak class="antialiased">
    <Toaster />
    <TooltipProvider>
      <RouterView />
    </TooltipProvider>
  </div>
</template>
